module.exports = __webpack_public_path__ + "img/BG_log_page.1102440f.jpg";